import React from "react";

// const SelectBox = ({
//   id,
//   label,
//   options,
//   register,
//   validationRules,
//   errorMessage,
// }) => {
//   return (
//     <div className="col-md-4">
//       <label htmlFor={id} className="form-label text-success small">
//         {label}
//       </label>
//       <select
//         className={`form-select form-select-sm ${
//           errorMessage ? "is-invalid" : ""
//         }`}
//         id={id}
//         {...register(id, validationRules)}
//       >
//         <option value="">Select {label}</option>
//         {options.map((option, index) => (
//           <option key={index} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </select>
//       {errorMessage && <div className="invalid-feedback">{errorMessage}</div>}
//     </div>
//   );
// };
//**************************************************************************** */
// export default SelectBox;

// const SelectBox = ({
//   id,
//   label,
//   options,
//   register,
//   validationRules,
//   errorMessage,
// }) => {
//   return (
//     <div className="col-md-4 mb-4">
//       <label
//         htmlFor={id}
//         className="form-label"
//         style={{
//           color: "#4CAF50",
//           fontWeight: "bold",
//           fontFamily: "'Poppins', sans-serif",
//           fontSize: "14px",
//         }}
//       >
//         {label}
//       </label>
//       <select
//         className={`form-select ${errorMessage ? "is-invalid" : ""}`}
//         id={id}
//         style={{
//           borderRadius: "6px",
//           borderColor: "#A5C586",
//           backgroundColor: "#F5F0E1",
//         }}
//         {...register(id, validationRules)}
//       >
//         <option value="">Select {label}</option>
//         {options.map((option, index) => (
//           <option key={index} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </select>
//       {errorMessage && (
//         <div className="invalid-feedback" style={{ color: "#d9534f" }}>
//           {errorMessage}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SelectBox;

//**************************************************************************************
const SelectBox = ({
  id,
  label,
  options,
  register,
  validationRules,
  errorMessage,
}) => {
  return (
    <div className="col-md-4 mb-3">
      <label
        htmlFor={id}
        className="form-label"
        style={{
          color: "#4CAF50",
          fontWeight: "bold",
          fontFamily: "'Poppins', sans-serif",
          fontSize: "14px",
        }}
      >
        {label}
      </label>
      <select
        className={`form-select ${errorMessage ? "is-invalid" : ""}`}
        id={id}
        style={{
          borderRadius: "8px",
          borderColor: "#CBD5E1",
          backgroundColor: "#FFFFFF",
          color: "#4B4B4B",
          
          padding: "7px",
        }}
        {...register(id, validationRules)}
      >
        <option value="">Select {label}</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errorMessage && (
        <div className="invalid-feedback" style={{ color: "#d9534f" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default SelectBox;

